import React, { useState } from 'react';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import styles from '../styles/MultiSelect.module.css';

interface MultiSelectProps<T> {
  items: { label: string; value: T }[];
  onChange: (selected: T[]) => void;
  width?: string;
  label?: string;
  disabled?: boolean;
}

function MultiSelect<T>(props: MultiSelectProps<T>) {
  const [selected, setSelected] = useState<T[]>([]);

  const handleChangeMultiple = (event: SelectChangeEvent<T[]>) => {
    event.preventDefault();
    const selected = event.target.value as T[];
    setSelected(selected);
    props.onChange(selected);
  };

  const getSelectedLabel = (value: T) => {
    return props.items.find((item) => item.value === value)?.label || '';
  };

  return (
    <FormControl
      sx={{ minWidth: 120, width: props.width || 'auto' }}
      variant="outlined"
      margin="dense"
      size="small"
    >
      <InputLabel id="mutiple-chip-label">
        {props.label || 'Filter by'}
      </InputLabel>
      <Select
        labelId="mutiple-chip-label"
        label={props.label || 'Filter by'}
        id="mutiple-chip"
        multiple
        MenuProps={{
          variant: 'menu'
        }}
        value={selected}
        disabled={props.disabled}
        onChange={handleChangeMultiple}
        renderValue={(selected: T[]) => (
          <div className={styles.chips}>
            {selected.map(
              (value) =>
                props.items.some((i) => i.value === value) && ( //To avoid showing empty chip label(Unassigned Assessments)
                  <Chip
                    key={value as any}
                    label={getSelectedLabel(value)}
                    className={styles.chip}
                    size="small"
                  />
                )
            )}
          </div>
        )}
      >
        {props.items.map((item) => {
          const value = item.value as unknown as T;
          return (
            <MenuItem key={value as any} value={value as any}>
              <Checkbox checked={selected.includes(value)} />
              <ListItemText primary={item.label} />
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}

export default MultiSelect;
